{
  "CONTACT_PANEL": {
    "NOT_AVAILABLE": "Tidak Tersedia",
    "EMAIL_ADDRESS": "Alamat Email",
    "PHONE_NUMBER": "Nomor Telepon",
    "IDENTIFIER": "Pengenal",
    "COPY_SUCCESSFUL": "Berhasil disalin ke clipboard",
    "COMPANY": "Perusahaan",
    "LOCATION": "Lokasi",
    "BROWSER_LANGUAGE": "Bahasa Browser",
    "CONVERSATION_TITLE": "Detail Percakapan",
    "VIEW_PROFILE": "Lihat Profil",
    "BROWSER": "Browser",
    "OS": "Sistem Operasi",
    "INITIATED_FROM": "Dimulai dari",
    "INITIATED_AT": "Dimulai pada",
    "IP_ADDRESS": "Alamat IP",
    "CREATED_AT_LABEL": "Dibuat",
    "NEW_MESSAGE": "Pesan baru",
    "CALL": "Call",
    "CALL_INITIATED": "Calling the contact…",
    "CALL_FAILED": "Unable to start the call. Please try again.",
    "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
    "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
    "CLICK_TO_EDIT": "Click to edit",
    "VOICE_INBOX_PICKER": {
      "TITLE": "Choose a voice inbox"
    },
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Tidak ada percakapan sebelumnya yang terkait dengan kontak ini.",
      "TITLE": "Percakapan Sebelumnya"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Label Kontak",
        "ERROR": "Tidak dapat mengupdate label"
      },
      "CONVERSATION": {
        "TITLE": "Label Percakapan",
        "ADD_BUTTON": "Tambah label"
      },
      "LABEL_SELECT": {
        "TITLE": "Tambah label",
        "PLACEHOLDER": "Cari label",
        "NO_RESULT": "Tidak ada label",
        "CREATE_LABEL": "Buat label baru"
      }
    },
    "MERGE_CONTACT": "Gabungkan Kontak",
    "CONTACT_ACTIONS": "Tindakan Kontak",
    "MUTE_CONTACT": "Block Contact",
    "UNMUTE_CONTACT": "Unblock Contact",
    "MUTED_SUCCESS": "This contact is blocked successfully. You will not be notified of any future conversations.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "SEND_TRANSCRIPT": "Kirim Transkrip",
    "EDIT_LABEL": "Edit",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Atribut Kustom",
      "CONTACT_LABELS": "Label Kontak",
      "PREVIOUS_CONVERSATIONS": "Percakapan Sebelumnya",
      "NO_RECORDS_FOUND": "Tidak ditemukan atribut"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Edit Kontak",
    "TITLE": "Edit kontak",
    "DESC": "Edit detail kontak"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Hapus Kontak",
    "TITLE": "Hapus kontak",
    "DESC": "Hapus detil kontak",
    "CONFIRM": {
      "TITLE": "Konfirmasi Penghapusan",
      "MESSAGE": "Apakah Anda yakin ingin menghapus ",
      "YES": "Ya, Hapus",
      "NO": "Tidak, Simpan"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kontak berhasil dihapus",
      "ERROR_MESSAGE": "Tidak dapat menghapus kontak. Silakan coba lagi nanti."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Kirim",
      "CANCEL": "Batalkan",
      "AVATAR": {
        "LABEL": "Avatar Kontak"
      },
      "NAME": {
        "PLACEHOLDER": "Masukkan nama lengkap kontak",
        "LABEL": "Nama Lengkap"
      },
      "BIO": {
        "PLACEHOLDER": "Masukkan biografi kontak",
        "LABEL": "Biografi"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Masukkan alamat email kontak",
        "LABEL": "Alamat Email",
        "DUPLICATE": "Alamat email ini digunakan untuk kontak lain.",
        "ERROR": "Harap masukkan alamat email yang valid."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Masukkan nomor telepon kontak tersebut",
        "LABEL": "Nomor Telepon",
        "HELP": "Nomor telepon harus dalam format E.164, misalnya: +1415555555 [+][kode negara][kode area][nomor telepon]",
        "ERROR": "Nomor telepon harus kosong atau dalam format E.164",
        "DIAL_CODE_ERROR": "Pilih kode panggilan dari daftar",
        "DUPLICATE": "Nomor ini sudah digunakan oleh kontak lain."
      },
      "LOCATION": {
        "PLACEHOLDER": "Masukkan lokasi kontak",
        "LABEL": "Lokasi"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Masukkan nama perusahaan",
        "LABEL": "Nama Perusahaan"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Masukkan nama negara",
        "LABEL": "Nama Negara",
        "SELECT_PLACEHOLDER": "Pilih",
        "REMOVE": "Hapus",
        "SELECT_COUNTRY": "Pilih Negara"
      },
      "CITY": {
        "PLACEHOLDER": "Masukkan nama kota",
        "LABEL": "Nama Kota"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Masukkan nama pengguna Facebook",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Edit nama pengguna Twitter",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Edit nama pengguna LinkedIn",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Edit nama pengguna GitHub",
          "LABEL": "GitHub"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Avatar kontak berhasil dihapus",
        "ERROR_MESSAGE": "Tidak dapat menghapus avatar kontak. Silakan coba lagi nanti."
      }
    },
    "SUCCESS_MESSAGE": "Kontak berhasil disimpan",
    "ERROR_MESSAGE": "Terjadi kesalahan, harap coba lagi"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Mulai Percakapan",
    "TITLE": "Percakapan baru",
    "DESC": "Mulai sebuah percakapan baru dengan mengirim pesan baru.",
    "NO_INBOX": "Tidak dapat menemukan kotak masuk untuk memulai percakapan baru dengan kontak ini.",
    "FORM": {
      "TO": {
        "LABEL": "Kepada"
      },
      "INBOX": {
        "LABEL": "Kotak Masuk",
        "PLACEHOLDER": "Pilih kotak masuk",
        "ERROR": "Pilih kotak masuk"
      },
      "SUBJECT": {
        "LABEL": "Subjek",
        "PLACEHOLDER": "Masukkan subjek",
        "ERROR": "Subjek tidak boleh kosong"
      },
      "MESSAGE": {
        "LABEL": "Pesan",
        "PLACEHOLDER": "Tulis pesan Anda di sini",
        "ERROR": "Pesan tidak boleh kosong"
      },
      "ATTACHMENTS": {
        "SELECT": "Choose files",
        "HELP_TEXT": "Drag and drop files here or choose files to attach"
      },
      "SUBMIT": "Kirim Pesan",
      "CANCEL": "Batalkan",
      "SUCCESS_MESSAGE": "Pesan terkirim!",
      "GO_TO_CONVERSATION": "Lihat",
      "ERROR_MESSAGE": "Tidak dapat mengirim pesan! Coba lagi"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Profil Sosial"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Tambahkan atribut kustom",
    "COPY_SUCCESSFUL": "Berhasil disalin ke clipboard",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Salin Atribut",
      "DELETE": "Hapus Atribut",
      "EDIT": "Edit Atribut"
    },
    "ADD": {
      "TITLE": "Buat Atribut Kustom",
      "DESC": "Tambahkan informasi kustom pada kontak ini."
    },
    "FORM": {
      "CREATE": "Tambahkan Atribut",
      "CANCEL": "Batalkan",
      "NAME": {
        "LABEL": "Nama Atribut Kustom",
        "PLACEHOLDER": "Misal: ID toko",
        "ERROR": "Nama atribut kustom tidak valid"
      },
      "VALUE": {
        "LABEL": "Nilai Atribut",
        "PLACEHOLDER": "Misal: 11901"
      },
      "ADD": {
        "TITLE": "Membuat Atribut Baru",
        "SUCCESS": "Atribut berhasil ditambahkan",
        "ERROR": "Tidak dapat membuat atribut, Silakan coba lagi nanti"
      },
      "UPDATE": {
        "SUCCESS": "Atribut berhasil diperbarui",
        "ERROR": "Tidak dapat memperbarui atribut, Silakan coba lagi nanti"
      },
      "DELETE": {
        "SUCCESS": "Atribut berhasil dihapus",
        "ERROR": "Tidak dapat menghapus atribut. Silakan coba lagi nanti"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Tambahkan Atribut",
        "PLACEHOLDER": "Cari atribut",
        "NO_RESULT": "Tidak ditemukan atribut"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Pilih nilai",
          "SEARCH_INPUT_PLACEHOLDER": "Cari nilai",
          "NO_RESULT": "Tidak ada hasil"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Nilai yang valid diperlukan",
      "INVALID_URL": "URL tidak valid",
      "INVALID_INPUT": "Masukan Tidak Valid"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Gabungkan Kontak",
    "DESCRIPTION": "Merge contacts to combine two profiles into one, including all attributes and conversations. In case of conflict, the Primary contact’ s attributes will take precedence.",
    "PRIMARY": {
      "TITLE": "Kontak Utama",
      "HELP_LABEL": "Akan dihapus"
    },
    "PARENT": {
      "TITLE": "Kontak yang akan Digabungkan",
      "PLACEHOLDER": "Cari kontak",
      "HELP_LABEL": "Akan tetap"
    },
    "SUMMARY": {
      "TITLE": "Ringkasan",
      "DELETE_WARNING": "Kontak <strong>{primaryContactName}</strong> akan dihapus.",
      "ATTRIBUTE_WARNING": "Detail kontak dari <strong>{primaryContactName}</strong> akan disalin ke <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": "Gabungkan Kontak",
      "CANCEL": "Batalkan",
      "CHILD_CONTACT": {
        "ERROR": "Pilih kontak yang akan digabungkan"
      },
      "SUCCESS_MESSAGE": "Kontak berhasil digabungkan",
      "ERROR_MESSAGE": "Tidak dapat menggabungkan kontak, coba lagi!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontak",
      "SEARCH_TITLE": "Search contacts",
      "ACTIVE_TITLE": "Active contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Pesan",
      "SEND_MESSAGE": "Kirim Pesan",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BREADCRUMB": {
        "CONTACTS": "Kontak"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Tambahkan kontak",
          "EXPORT_CONTACT": "Ekspor kontak",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Simpan kontak",
          "EMAIL_ADDRESS_DUPLICATE": "Alamat email ini digunakan untuk kontak lain.",
          "PHONE_NUMBER_DUPLICATE": "Nomor ini sudah digunakan oleh kontak lain.",
          "SUCCESS_MESSAGE": "Kontak berhasil disimpan",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "This contact is blocked successfully",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Impor kontak",
          "DESCRIPTION": "Impor kontak melalui file CSV.",
          "DOWNLOAD_LABEL": "Unduh contoh file CSV.",
          "LABEL": "File CSV:",
          "CHOOSE_FILE": "Pilih berkas",
          "CHANGE": "Ubah",
          "CANCEL": "Batalkan",
          "IMPORT": "Impor",
          "SUCCESS_MESSAGE": "You will be notified via email when the import is complete.",
          "ERROR_MESSAGE": "Terjadi kesalahan, harap coba lagi"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Ekspor kontak",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Ekspor",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Terjadi kesalahan, harap coba lagi"
        },
        "SORT_BY": {
          "LABEL": "Urutkan berdasarkan",
          "OPTIONS": {
            "NAME": "Nama",
            "EMAIL": "Email",
            "PHONE_NUMBER": "Nomor Telepon",
            "COMPANY": "Perusahaan",
            "COUNTRY": "Negara",
            "CITY": "Kota",
            "LAST_ACTIVITY": "Aktivitas terakhir",
            "CREATED_AT": "Dibuat pada"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Apakah Anda ingin menyimpan filter ini?",
            "CONFIRM": "Simpan filter",
            "LABEL": "Nama",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Konfirmasi Penghapusan",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Ya, Hapus",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Nama",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Nomor Telepon",
      "IDENTIFIER": "Pengenal",
      "COUNTRY": "Negara",
      "CITY": "Kota",
      "COMPANY": "Perusahaan",
      "CREATED_AT": "Dibuat pada",
      "LAST_ACTIVITY": "Aktivitas terakhir",
      "REFERER_LINK": "Tautan Referer",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "Benar",
      "BLOCKED_FALSE": "Salah",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Terapkan filter",
        "ADD_FILTER": "Tambah filter"
      },
      "TITLE": "Filter kontak",
      "EDIT_SEGMENT": "Edit Segmen",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "Lihat Detail",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Edit detail kontak",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name"
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "Alamat email ini digunakan untuk kontak lain."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "Nomor ini sudah digunakan oleh kontak lain."
          },
          "CITY": {
            "PLACEHOLDER": "Masukkan nama kota"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Masukkan nama perusahaan"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "TELEGRAM": {
            "PLACEHOLDER": "Add Telegram"
          },
          "TIKTOK": {
            "PLACEHOLDER": "Add TikTok"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      },
      "DELETE_CONTACT": {
        "MESSAGE": "This action is permanent and irreversible.",
        "BUTTON": "Delete now"
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Hapus kontak",
      "DELETE_DIALOG": {
        "TITLE": "Konfirmasi Penghapusan",
        "DESCRIPTION": "Are you sure you want to delete this contact?",
        "CONFIRM": "Ya, Hapus",
        "API": {
          "SUCCESS_MESSAGE": "Kontak berhasil dihapus",
          "ERROR_MESSAGE": "Tidak dapat menghapus kontak. Silakan coba lagi nanti."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar berhasil dihapus",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Atribut",
        "HISTORY": "History",
        "NOTES": "Catatan",
        "MEDIA": "Media",
        "MERGE": "Merge"
      },
      "HISTORY": {
        "EMPTY_STATE": "Tidak ada percakapan sebelumnya yang terkait dengan kontak ini"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Ya",
        "NO": "Tidak",
        "TRIGGER": {
          "SELECT": "Pilih nilai",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Nilai yang valid diperlukan",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "URL tidak valid",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "Tidak ditemukan atribut",
        "API": {
          "SUCCESS_MESSAGE": "Atribut berhasil diperbarui",
          "DELETE_SUCCESS_MESSAGE": "Atribut berhasil dihapus",
          "UPDATE_ERROR": "Tidak dapat memperbarui atribut, Silakan coba lagi nanti",
          "DELETE_ERROR": "Tidak dapat menghapus atribut. Silakan coba lagi nanti"
        }
      },
      "MERGE": {
        "TITLE": "Gabungkan Kontak",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Kontak Utama",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "Akan dihapus",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Cari kontak",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Kontak berhasil digabungkan",
        "ERROR_MESSAGE": "Tidak dapat menggabungkan kontak, coba lagi!",
        "IS_SEARCHING": "Sedang mencari...",
        "BUTTONS": {
          "CANCEL": "Batalkan",
          "CONFIRM": "Gabungkan Kontak"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Tambahkan Catatan",
        "WROTE": "menulis",
        "YOU": "Anda",
        "SAVE": "Save note",
        "ADD_NOTE": "Add contact note",
        "EXPAND": "Expand",
        "COLLAPSE": "Collapse",
        "NO_NOTES": "No notes, you can add notes from the contact details page.",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above.",
        "CONVERSATION_EMPTY_STATE": "There are no notes yet. Use the Add note button to create one."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Tambahkan kontak",
      "SEARCH_EMPTY_STATE_TITLE": "Tidak ada kontak yang cocok dengan pencarian Anda 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋",
      "ACTIVE_EMPTY_STATE_TITLE": "No contacts are active at the moment 🌙"
    },
    "LOAD_MORE": "Load more"
  },
  "CONTACTS_BULK_ACTIONS": {
    "ASSIGN_LABELS": "Tugaskan Label",
    "REMOVE_LABELS": "Remove Labels",
    "ASSIGN_LABELS_SUCCESS": "Label berhasil ditugaskan.",
    "ASSIGN_LABELS_FAILED": "Failed to assign labels",
    "REMOVE_LABELS_SUCCESS": "Labels removed successfully.",
    "REMOVE_LABELS_FAILED": "Failed to remove labels",
    "DESCRIPTION": "Select the labels you want to add to the selected contacts.",
    "NO_LABELS_FOUND": "No labels available yet.",
    "SELECTED_COUNT": "{count} selected",
    "CLEAR_SELECTION": "Clear selection",
    "SELECT_ALL": "Select all ({count})",
    "DELETE_CONTACTS": "Hapus",
    "DELETE_SUCCESS": "Contacts deleted successfully.",
    "DELETE_FAILED": "Failed to delete contacts.",
    "DELETE_DIALOG": {
      "TITLE": "Delete selected contacts",
      "SINGULAR_TITLE": "Delete selected contact",
      "DESCRIPTION": "This will permanently delete {count} selected contacts. This action cannot be undone.",
      "SINGULAR_DESCRIPTION": "This will permanently delete the selected contact. This action cannot be undone.",
      "CONFIRM_MULTIPLE": "Delete contacts",
      "CONFIRM_SINGLE": "Hapus kontak"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Lihat",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "Kepada:",
        "TAG_INPUT_PLACEHOLDER": "Enter at least 2 characters to search by name, email, or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Masukkan subjek :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Enter at least 2 characters to search by email",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Enter at least 2 characters to search by email",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Tulis pesan Anda di sini..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Variabel",
          "BACK": "Kembali",
          "SEND_MESSAGE": "Kirim Pesan"
        }
      },
      "TWILIO_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "BACK": "Kembali",
          "SEND_MESSAGE": "Kirim Pesan"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Send ({keyCode})"
      }
    }
  }
}
